// Centralized p5.js version configuration
// Change versions here to update everywhere in the app

export const P5_VERSIONS = ['1.11.3', '1.9.4', '1.7.0', '2.1.1', '2.0.5']
export const DEFAULT_P5_VERSION = '1.11.3'

// CDN URLs
export const getP5CdnUrl = (version) => `https://cdn.jsdelivr.net/npm/p5@${version}/lib/p5.min.js`
export const getP5SoundCdnUrl = (version) => `https://cdn.jsdelivr.net/npm/p5@${version}/lib/addons/p5.sound.min.js`
